import loggerModule from './logger/logger';
import knownDeviceModule from './known-device/known-device';

export const logger = loggerModule;
export const knownDevice = knownDeviceModule;
